import { Map } from 'immutable';
// immutable has many good use cases. Read more at: https://immutable-js.github.io/immutable-js/
import { ADD_USER, UPDATE_USER, DELETE_USER, POPULATE_USERS, USER_SUB_LIST } from '@constants/actions';

const initialState = Map({
  userList: [],
  totalCount: 0,
});

const Users = (state = initialState, action: any) => {
  const user = action.payload ? action.payload.user : null;
  switch(action.type) {
    case POPULATE_USERS:
      const { users, totalCount } = action.payload;
      return state.set('userList', users)
        .set('totalCount', totalCount);
    case ADD_USER:
    case UPDATE_USER:
      return state.set(user.guid, user);
    case DELETE_USER:
      return state.delete(user.guid);
    default:
      return state;
  }
};

export default Users;